console.log("CUSTOM JS LOADED");

document.addEventListener("DOMContentLoaded", function () {

    function attachReviewLinks() {

        document.querySelectorAll(".product-item").forEach(function(card){

            const productLink = card.querySelector(".card-title a");
            const widget = card.querySelector(".yotpo-sr-bottom-line-summary");

            if (!productLink || !widget) return;

            widget.style.cursor = "pointer";

            widget.onclick = function(e){

                e.preventDefault();
                e.stopPropagation();

                window.location.href =
                    productLink.href + "#yotpo-reviews-main-widget";

            };

        });

    }

    // Wait for Yotpo to finish rendering
    setTimeout(attachReviewLinks, 1000);
    setTimeout(attachReviewLinks, 3000);

});

document.addEventListener('click', function (e) {
    const review = e.target.closest('.card-review');

    if (!review) return;

    e.preventDefault();
    e.stopPropagation();

    const productCard = review.closest('.product-item');
    if (!productCard) return;

    const productLink = productCard.querySelector('.card-title');

    if (!productLink) return;

    window.location.assign(productLink.href + '#yotpo-reviews-main-widget');

}, true);

window.addEventListener('load', function () {
    if (window.location.hash === '#yotpo-reviews-main-widget') {
        const reviews = document.getElementById('yotpo-reviews-main-widget');

        if (reviews) {
            reviews.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        }
    }
});


document.addEventListener("DOMContentLoaded", function () {

    function hideZeroReviewWidgets() {

        document.querySelectorAll(".card-review").forEach(function(card){

            const srOnly = card.querySelector(".sr-only");

            if (!srOnly) return;

            if (srOnly.textContent.trim().startsWith("0 out")) {

                const widget = card.querySelector(".yotpo-sr-bottom-line-summary");

                if (widget) {

                    widget.style.visibility = "hidden";
                    widget.style.pointerEvents = "none";

                }

            }

        });

    }

    setTimeout(hideZeroReviewWidgets,1000);
    setTimeout(hideZeroReviewWidgets,3000);

});

document.addEventListener('DOMContentLoaded', () => {
    const observer = new MutationObserver(() => {
        const select = document.querySelector('.flits-cart-automatic-code select');

        if (!select) return;

        if (select.options.length) {
            select.options[0].text = 'Choose your reward';
        }

        observer.disconnect();
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
});